import extractErrorMessage from '../utils/extractErrorMessage';
import { authClient } from './client';

export const uploadImage = async (file) => {
  try {
    const formData = new FormData();
    formData.append('image', file);

    const response = await authClient.post('/upload-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return {
      data: response.data,
      error: null,
    };
  } catch (error) {
    const message = extractErrorMessage(error, 'Greska pri otpremanju slike.');
    return {
      data: null,
      error: message,
    };
  }
};

export const uploadDetachedImage = async (file) => {
  try {
    const formData = new FormData();
    formData.append('image', file);

    const response = await authClient.post('/upload-image/detached', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return {
      data: response.data,
      error: null,
    };
  } catch (error) {
    const message = extractErrorMessage(error, 'Greska pri otpremanju slike saglasnosti.');
    return {
      data: null,
      error: message,
    };
  }
};

export const uploadMultipleImages = async (files) => {
  try {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('images', file);
    });

    const response = await authClient.post('/upload-multiple-images', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return {
      data: response.data,
      error: null,
    };
  } catch (error) {
    const message = extractErrorMessage(error, 'Greska pri otpremanju slika.');
    return {
      data: null,
      error: message,
    };
  }
};

export const deleteImage = async (imageId) => {
  try {
    const response = await authClient.delete(`/images/${imageId}`);

    return {
      data: response.data,
      error: null,
    };
  } catch (error) {
    const message = extractErrorMessage(error, 'Greska pri brisanju slike.');
    return {
      data: null,
      error: message,
    };
  }
};
